/* eslint-disable max-classes-per-file */
import { Quill } from "react-quill";

type VariableTagPayload = {
  marker: string;
  title: string;
}

const Embed = Quill.import("blots/embed");

class QuillVariableTag extends Embed {
  static blotName = "VariableTag";

  static tagName = "span";

  static className = "VariableTag";

  static create (value: VariableTagPayload) {
    const node = super.create(value) as HTMLElement;

    // Set up the badge, and badge colour
    node.setAttribute("class", "badge-tmpl");

    // The marker is the $ rel_table[id] reference
    node.setAttribute("data-marker", value.marker);

    node.setAttribute("data-title", value.title);

    // The title is what the user sees in their editor
    node.innerHTML = value.title;

    return node;
  }

  static value (node: HTMLElement): VariableTagPayload {
    return {
      marker: node.getAttribute("data-marker") || "",
      title: node.getAttribute("data-title") || "",
    };
  }
}

// don't let people paste in bad styles from Word

const Clipboard = Quill.import("modules/clipboard");
const Delta = Quill.import("delta");

class PlainClipboard extends Clipboard {
  onPaste (e: ClipboardEvent) {
    e.preventDefault();
    const range = this.quill.getSelection() as { index: number; length: number } | null;
    if (!range) {
      return;
    }

    const text = e.clipboardData?.getData("text/plain") || "";
    const delta = new Delta().retain(range.index).delete(range.length).insert(text);
    const index = text.length + range.index;
    const length = 0;
    this.quill.updateContents(delta, "silent");
    this.quill.setSelection(index, length, "silent");
    this.quill.scrollIntoView();
  }
}

Quill.register({
  "formats/VariableTag": QuillVariableTag,
  "modules/clipboard": PlainClipboard,
}, true);

export default QuillVariableTag;
